import { Navigate } from "react-router-dom";
import { webPaths } from "../routes/pageRoutes";
import { pipGetAccessToken } from "../utils/pip";
const PrivateRoute = ({ children }) => {
  const {isLogin} = pipGetAccessToken();                                                                        
  return isLogin ? children : <Navigate to={webPaths?.Login} />;
};

export default PrivateRoute;
